const WSHINGWELL_SERVICE_PERCENT = 0.03;
const WSHINGWELL_ATTENDEE_CUT = 1.0;
const WSHINGWELL_TRANSACTION_CUT = 0;
export {
  WSHINGWELL_SERVICE_PERCENT,
  WSHINGWELL_ATTENDEE_CUT,
  WSHINGWELL_TRANSACTION_CUT
};
